/**
 * Opciones y columnas para el formulario de búsqueda de recibos.
 */

export const estadosReciboOptions = [
  { value: '0', label: 'Pendiente' },
  { value: '1', label: 'Cobrado' },
  { value: '2', label: 'Devuelto' },
  { value: '3', label: 'Retenido' },
  { value: '4', label: 'Abonado' },
  { value: '5', label: 'Impagado' },
  { value: '6', label: 'Incobrable' },
];

export const formasPagoOptions = [
  { value: '0', label: 'Contado Efectivo' },
  { value: '1', label: 'Tarjeta Crédito' },
  { value: '2', label: 'Recibo Domiciliado' },
  { value: '3', label: 'Transferencia' },
  { value: '4', label: 'Talón o Cheque' },
  { value: '5', label: 'Financiado' },
  { value: '6', label: 'Stripe' },
  { value: '7', label: 'Pago Débito' },
  { value: '8', label: 'Redsys' },
];

export const tableColumns = [
  { Header: 'Empresa', accessor: 'empresa' },
  { Header: 'Recibo', accessor: 'recibo' },
  { Header: 'Factura', accessor: 'factura' },
  { Header: 'Fecha de Emisión', accessor: 'fecha_emision' },
  { Header: 'Fecha de Vencimiento', accessor: 'fecha_vto' },
  { Header: 'Vencimiento Aplazado', accessor: 'vencimiento_aplazado' },
  { Header: 'Fecha de Cobro', accessor: 'fecha_cobro' },
  { Header: 'Cliente', accessor: 'cliente' },
  { Header: 'Centro', accessor: 'idcentro' },
  { Header: 'Nombre', accessor: 'nombre' },
  { Header: 'Tipo de Cliente', accessor: 'tipo_cliente' },
  { Header: 'Forma de Pago', accessor: 'forma_de_pago' },
  { Header: 'Concepto', accessor: 'concepto' },
  { Header: 'Importe', accessor: 'importe' },
  { Header: 'Estado', accessor: 'estado' },
  { Header: 'Facturado', accessor: 'facturado' },
  { Header: 'Caja', accessor: 'caja' },
  { Header: 'Sede', accessor: 'sede' },
  { Header: 'Referencia', accessor: 'referencia' },
  { Header: 'Apellido Alumno', accessor: 'Apellido_Alumno' },
  { Header: 'Nombre Alumno', accessor: 'Nombre_Alumno' },
  { Header: 'Grupo', accessor: 'GRUPO' },
  { Header: 'Estado de Matrícula', accessor: 'Estado_Matricula' },
  { Header: 'Fecha de Baja', accessor: 'Fecha_baja' },
  { Header: 'Motivo de Baja', accessor: 'MotivoBaja' },
];
